import { createContext, useState, useRef } from "react"

export const ModalsContext = createContext()
ModalsContext.displayName = "ModalsContext"

export function ModalsProvider({ children }) {
  const [modals, setModals] = useState([])
  const lastModalKey = useRef(0)

  return (
    <ModalsContext.Provider value={{ modals, setModals, lastModalKey }}>
      {children}
    </ModalsContext.Provider>
  )
}
